
let selects = Array.from(document.querySelectorAll('.faux-select'))

if(selects.length > 0) {
    selects.forEach( select => {

        let label = select.querySelector('.faux-select--label')

        let items = select.querySelectorAll('.faux-select--list label')
        let inputs = select.querySelectorAll('.faux-select--inputs input')

        let checked = select.querySelector('.faux-select--inputs input[checked="checked"]')
        if(checked) {
            label.querySelector('span').innerHTML = checked.getAttribute('id')
        }

        label.addEventListener('click', e => {
            select.classList.toggle('active')
            e.stopPropagation()
        })

        items.forEach( item => {
            item.addEventListener('click', e => {
                select.classList.remove('active')
                e.stopPropagation()
            })
        })

        inputs.forEach( input => {
            input.addEventListener('change', e => {

                let item = select.querySelector(`[for="${e.target.getAttribute('id')}"]`)
                label.querySelector('span').innerHTML = item.innerHTML

                if(select.classList.contains('placeholder')) {
                    select.classList.remove('placeholder')
                }
            })
        })

        document.body.addEventListener('click', e => {
            select.classList.remove('active')
        })
    })
}
